import React, { useState } from 'react';
import { InputNumber, Tooltip as AntTooltip } from 'antd';
import {
  AimOutlined,
  DeleteOutlined,
  PlusOutlined,
  UndoOutlined,
} from '@ant-design/icons';

/**
 * Distances used as the "Distanza [m]" of the SYNCFIX tratte. Each value can
 * come from the ruler on either map or be typed straight into the last row,
 * and stays editable until the transfer.
 */
export default function MeasurementList({
  measurements = [],
  onChange,
  onAdd,
  onRemove,
  onUndo,
  onClear,
  onFocus,
}) {
  const [draft, setDraft] = useState(null);

  const commitDraft = () => {
    const value = Number(draft);
    setDraft(null);
    if (!Number.isFinite(value) || value <= 0) return;
    onAdd?.(value);
  };

  return (
    <div className="semafix-measure-block">
      <div className="semafix-measure-head">
        <div>
          <b>Distanza [m]</b>
          <span>
            {measurements.length
              ? `${measurements.length} tratte verso SYNCFIX`
              : 'Misura col righello o scrivi il valore'}
          </span>
        </div>
        {measurements.length > 0 && (
          <div className="semafix-measure-actions">
            <AntTooltip title="Annulla ultima misura">
              <button type="button" aria-label="Annulla ultima misura" onClick={onUndo}>
                <UndoOutlined />
              </button>
            </AntTooltip>
            <AntTooltip title="Cancella misure">
              <button type="button" aria-label="Cancella misure" onClick={onClear}>
                <DeleteOutlined />
              </button>
            </AntTooltip>
          </div>
        )}
      </div>

      {measurements.length > 0 && (
        <ul className="semafix-measure-rows">
          {measurements.map((measurement, index) => (
            <li key={measurement.id}>
              <span className="semafix-measure-index">{index + 1}</span>
              <InputNumber
                size="small"
                min={1}
                step={1}
                value={Math.round(measurement.distanceMeters)}
                onChange={(value) => onChange?.(measurement.id, value)}
                aria-label={`Distanza tratta ${index + 1} in metri`}
              />
              <span className="semafix-measure-unit">m</span>
              {onFocus && measurement.from && measurement.to && (
                <AntTooltip title="Centra sulla misura">
                  <button
                    type="button"
                    aria-label={`Centra misura ${index + 1}`}
                    onClick={() => onFocus(measurement)}
                  >
                    <AimOutlined />
                  </button>
                </AntTooltip>
              )}
              <AntTooltip title="Elimina distanza">
                <button
                  type="button"
                  className="danger"
                  aria-label={`Elimina distanza ${index + 1}`}
                  onClick={() => onRemove?.(measurement.id)}
                >
                  <DeleteOutlined />
                </button>
              </AntTooltip>
            </li>
          ))}
        </ul>
      )}

      {/* Always available, so a distance can be set without measuring. */}
      {onAdd && (
        <div className="semafix-measure-draft">
          <span className="semafix-measure-index">+</span>
          <InputNumber
            size="small"
            min={1}
            step={1}
            value={draft}
            placeholder="Valore manuale"
            onChange={setDraft}
            onPressEnter={commitDraft}
            onBlur={commitDraft}
            aria-label="Nuova distanza in metri"
          />
          <span className="semafix-measure-unit">m</span>
          <AntTooltip title="Aggiungi distanza">
            <button
              type="button"
              aria-label="Aggiungi distanza"
              disabled={!(Number(draft) > 0)}
              onClick={commitDraft}
            >
              <PlusOutlined />
            </button>
          </AntTooltip>
        </div>
      )}
    </div>
  );
}
